import React from 'react';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const SuccessLoginModal: React.FC<SuccessModalProps> = ({ isOpen, message }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-auto bg-black bg-opacity-50 flex" data-testid="success-modal-overlay">
      <div className="relative p-6 bg-white w-11/12 max-w-md m-auto flex-col flex rounded-lg" data-testid="success-modal-container">
        <div className="flex items-center justify-center mb-4" data-testid="success-modal-icon-container">
          <svg 
            className="w-16 h-16 text-green-500" 
            fill="currentColor" 
            viewBox="0 0 20 20" 
            xmlns="http://www.w3.org/2000/svg"
            data-testid="success-modal-icon"
          >
            <path 
              fillRule="evenodd" 
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" 
              clipRule="evenodd" 
            />
          </svg>
        </div>
        <div className="text-center mb-4" data-testid="success-modal-content">
          <h3 className="text-xl font-semibold text-gray-900 mb-2" data-testid="success-modal-title">¡Éxito!</h3>
          <p className="text-gray-600" data-testid="success-modal-message">{message}</p>
        </div>
        {/*<button*/}
        {/*  className="px-4 py-2 bg-green-500 text-white text-base font-medium rounded-md shadow-sm hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-300"*/}
        {/*  onClick={onClose}*/}
        {/*  data-testid="success-modal-close-button"*/}
        {/*>*/}
        {/*  Aceptar*/}
        {/*</button>*/}
      </div>
    </div>
  );
};

export default SuccessLoginModal;